import React, { useRef } from 'react';
import { Hero } from '../components/Home/Hero';
import { Carousel } from '../components/Home/Carousel';
import { Stats } from '../components/Home/Stats';
import { UpcomingEvents } from '../components/Home/UpcomingEvents';
import { CitiesMap } from '../components/Home/CitiesMap';
import { SuccessStories } from '../components/Home/SuccessStories';
import { Newsletter } from '../components/Home/Newsletter';
import { MembershipAnnouncement } from '../components/Home/MembershipAnnouncement';
import { MembershipBenefits } from '../components/Home/MembershipBenefits';
import { CommunityStructure } from '../components/Home/CommunityStructure';
import { LifetimeAccess } from '../components/Home/LifetimeAccess';
import { AccessPoints } from '../components/Home/AccessPoints';
import { FinalCTA } from '../components/Home/FinalCTA';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
interface HomeProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
  openPaymentForm?: () => void;
}
export const Home = ({
  openRegistrationForm,
  openHostSalonForm,
  openPaymentForm
}: HomeProps) => {
  const accessPointsRef = useRef<HTMLDivElement>(null);
  const scrollToAccessPoints = () => {
    if (accessPointsRef.current) {
      accessPointsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const openCorporateTrainingForm = () => {
    if (window.openCorporateTrainingForm) {
      window.openCorporateTrainingForm();
    }
  };
  const carouselImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg',
    alt: 'The Networking Salon group photo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg',
    alt: 'Five women at The Networking Salon event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg',
    alt: 'Four people at The Networking Salon event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1BbFm8kmubumv56AGcAZxq/1755202597061.jpg',
    alt: 'The Networking Salon event'
  }];
  return <div data-id="element-1569">
      <Hero openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} openPaymentForm={openPaymentForm} scrollToAccessPoints={scrollToAccessPoints} data-id="element-1570" />
      <MembershipBenefits data-id="element-1571" />
      <Stats data-id="element-1572" />
      <section className="py-16 border-b-2 border-gray-300" data-id="element-1573">
        <div className="container mx-auto px-4" data-id="element-1574">
          <h2 className="text-3xl font-bold mb-12 text-center" data-id="element-1575">
            Our Salons Around the World
          </h2>
          <Carousel images={carouselImages} data-id="element-1576" />
        </div>
      </section>
      <CommunityStructure data-id="element-1577" />
      <SuccessStories data-id="element-1578" />
      <UpcomingEvents data-id="element-1579" />
      <section className="py-16 border-b border-gray-200" data-id="element-1580">
        <div className="container mx-auto px-4" data-id="element-1581">
          <div className="flex flex-col md:flex-row justify-center gap-4" data-id="element-1582">
            <Button onClick={scrollToAccessPoints} data-id="element-1583">Join the Salon</Button>
            <Link to="/host-salon" data-id="element-1584">
              <Button variant="outline" data-id="element-1585">Host a Salon</Button>
            </Link>
            <Link to="/partner-with-us" data-id="element-1586">
              <Button variant="outline" data-id="element-1587">Partner with Us</Button>
            </Link>
          </div>
        </div>
      </section>
      <div ref={accessPointsRef} data-id="element-1588">
        <AccessPoints openPaymentForm={openPaymentForm} openCorporateTrainingForm={openCorporateTrainingForm} data-id="element-1589" />
      </div>
      <FinalCTA openPaymentForm={openPaymentForm} scrollToAccessPoints={scrollToAccessPoints} data-id="element-1590" />
      <Newsletter data-id="element-1591" />
    </div>;
};